import React, { FC, RefObject, useEffect, useState } from "react"

interface IFlatList<T> {
  scrollView: RefObject<HTMLElement | null>
  scrollPanel: RefObject<HTMLElement | null>
  data: T[]
  targetId?: string
  renderCount?: number
  RenderItem: (state: T) => React.ReactNode
}

const EmptyBlock: FC<{ height: number }> = ({ height }) => <div style={{ width: '100%', height }} />

const FlatList = <T extends {},>({
  data,
  renderCount = 5,
  RenderItem,
  scrollView,
  scrollPanel
}: IFlatList<T>): React.ReactElement => {
  const [countRender, setCountRender] = useState<number>(renderCount)
  const [list, setList] = useState<Array<T | number>>([...data.slice(0, countRender), data.length - countRender])
  const [itemHeight, setItemHeight] = useState<number>(0)
  const [scroll, setScroll] = useState<number>(0)
  const viewHeight: number = scrollPanel.current ? scrollPanel.current?.offsetHeight : 0

  useEffect(() => {
    clarificationWidth()
    addListener()
  }, [])

  useEffect(() => {
    if (!viewHeight) return
    const different = Math.floor(viewHeight / itemHeight)
    const view: number = Math.floor((viewHeight + scroll) / itemHeight)
    if (view + different > countRender) setCountRender(countRender + different)
  }, [scroll])

  useEffect(() => {
    setList([...data.slice(0, countRender), data.length - countRender])
  }, [countRender])

  const addListener = () => {
    scrollPanel?.current && scrollPanel.current
      .addEventListener('scroll', (e: any) => setScroll(e.target.scrollTop))
  }

  const clarificationWidth = () => {
    const offsetHeight = scrollView.current?.offsetHeight
    offsetHeight && setItemHeight(Math.floor(offsetHeight / renderCount))
  }

  return <>
    {list.map((block: T | number, index: number) => typeof block === 'number'
      ? <EmptyBlock height={block * itemHeight} key={index} />
      : RenderItem(block))}
  </>
}

export default FlatList
